/**
 * Created by fers on 23.05.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, IntlShape} from 'react-intl';

export default class InvalidQuery extends React.Component {
    static propTypes = {
        viewWithData: PropTypes.object,
    };

    render() {
        return (
            <div className="dativeryPlatformBox">
                <div className="dativeryPlatformTitle">
                    <div className={"channel-logo-32x32"}></div>
                </div>
                <div className="dativeryPlatformContent dativeryPlatformContentError">
                    <small><strong><i aria-hidden="true" className="fa fa-lg fa-exclamation-triangle"></i>{" "}<FormattedMessage defaultMessage="Invalid query" id="invalidQuery.title" /></strong></small>
                    <p><small><FormattedMessage defaultMessage="The query is invalid and can't be processed." id="invalidQuery.explanation" /></small></p>
                </div>
            </div>
        );
    }
}
